/**
 * mock-skills-data.ts
 *
 * Shared mock skills taxonomy. Used by:
 *  - pages/skills.tsx           (Skills page table + drawer)
 *  - components/resource-request-modal.tsx  (Skills section in request drawer)
 *
 * TODO: Replace with GET /api/resources/skills when backend is ready.
 */

export interface SkillResource {
  personId: string;
  personName: string;
  role: string;
  proficiency: 1 | 2 | 3 | 4 | 5;
  photo?: string;
}

export interface Skill {
  skillId: string;
  skillName: string;
  category: string;
  resourceCount: number;
  resources: SkillResource[];
}

export const MOCK_SKILLS: Skill[] = [
  // ── Technical ──────────────────────────────────────────────────────────────
  {
    skillId: 'sk-react',
    skillName: 'React',
    category: 'Technical',
    resourceCount: 5,
    resources: [
      { personId: 'p4', personName: 'David Smith', role: 'Lead Developer', proficiency: 5, photo: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400' },
      { personId: 'p5', personName: 'Emma Wilson', role: 'Senior Developer', proficiency: 5, photo: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400' },
      { personId: 'p12', personName: 'Liam Harris', role: 'Developer', proficiency: 4, photo: 'https://images.unsplash.com/photo-1463453091185-61582044d556?w=400' },
      { personId: 'p-alex', personName: 'Alexander Lee', role: 'Developer', proficiency: 5, photo: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400' },
      { personId: 'p-lucas', personName: 'Lucas Thompson', role: 'Developer', proficiency: 5, photo: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400' },
    ],
  },
  {
    skillId: 'sk-ts',
    skillName: 'TypeScript',
    category: 'Technical',
    resourceCount: 4,
    resources: [
      { personId: 'p4', personName: 'David Smith', role: 'Lead Developer', proficiency: 5, photo: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400' },
      { personId: 'p5', personName: 'Emma Wilson', role: 'Senior Developer', proficiency: 5, photo: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400' },
      { personId: 'p-alex', personName: 'Alexander Lee', role: 'Developer', proficiency: 5, photo: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400' },
      { personId: 'p-lucas', personName: 'Lucas Thompson', role: 'Developer', proficiency: 5, photo: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400' },
    ],
  },
  {
    skillId: 'sk-nodejs',
    skillName: 'Node.js',
    category: 'Technical',
    resourceCount: 4,
    resources: [
      { personId: 'p4', personName: 'David Smith', role: 'Lead Developer', proficiency: 5, photo: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400' },
      { personId: 'p12', personName: 'Liam Harris', role: 'Developer', proficiency: 5, photo: 'https://images.unsplash.com/photo-1463453091185-61582044d556?w=400' },
      { personId: 'p-james', personName: 'James Taylor', role: 'Developer', proficiency: 5, photo: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400' },
      { personId: 'p-david-m', personName: 'David Martinez', role: 'DevOps Engineer', proficiency: 2, photo: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400' },
    ],
  },
  {
    skillId: 'sk-aws',
    skillName: 'AWS',
    category: 'Technical',
    resourceCount: 3,
    resources: [
      { personId: 'p4', personName: 'David Smith', role: 'Lead Developer', proficiency: 4, photo: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400' },
      { personId: 'p14', personName: 'Noah Martin', role: 'Solutions Architect', proficiency: 5, photo: 'https://images.unsplash.com/photo-1519345182560-3f2917c472ef?w=400' },
      { personId: 'p10', personName: 'James Anderson', role: 'DevOps Engineer', proficiency: 4, photo: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400' },
    ],
  },
  {
    skillId: 'sk-azure',
    skillName: 'Azure',
    category: 'Technical',
    resourceCount: 3,
    resources: [
      { personId: 'p5', personName: 'Emma Wilson', role: 'Senior Developer', proficiency: 4, photo: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400' },
      { personId: 'p14', personName: 'Noah Martin', role: 'Solutions Architect', proficiency: 5, photo: 'https://images.unsplash.com/photo-1519345182560-3f2917c472ef?w=400' },
      { personId: 'p-marcus', personName: 'Marcus Webb', role: 'DevOps Engineer', proficiency: 4, photo: 'https://images.unsplash.com/photo-1463453091185-61582044d556?w=400' },
    ],
  },
  {
    skillId: 'sk-sql',
    skillName: 'SQL',
    category: 'Technical',
    resourceCount: 3,
    resources: [
      { personId: 'p6', personName: 'Frank Brown', role: 'Business Analyst', proficiency: 4, photo: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400' },
      { personId: 'p8', personName: 'Henry Evans', role: 'Data Analyst', proficiency: 5, photo: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400' },
      { personId: 'p5', personName: 'Emma Wilson', role: 'Senior Developer', proficiency: 3, photo: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400' },
    ],
  },
  {
    skillId: 'sk-kubernetes',
    skillName: 'Kubernetes',
    category: 'Technical',
    resourceCount: 3,
    resources: [
      { personId: 'p10', personName: 'James Anderson', role: 'DevOps Engineer', proficiency: 5, photo: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400' },
      { personId: 'p4', personName: 'David Smith', role: 'Lead Developer', proficiency: 4, photo: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400' },
      { personId: 'p-marcus', personName: 'Marcus Webb', role: 'DevOps Engineer', proficiency: 4, photo: 'https://images.unsplash.com/photo-1463453091185-61582044d556?w=400' },
    ],
  },
  {
    skillId: 'sk-python',
    skillName: 'Python',
    category: 'Technical',
    resourceCount: 2,
    resources: [
      { personId: 'p8', personName: 'Henry Evans', role: 'Data Analyst', proficiency: 4, photo: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400' },
      { personId: 'p14', personName: 'Noah Martin', role: 'Solutions Architect', proficiency: 3, photo: 'https://images.unsplash.com/photo-1519345182560-3f2917c472ef?w=400' },
    ],
  },
  // ── Design ──────────────────────────────────────────────────────────────────
  {
    skillId: 'sk-ui-ux',
    skillName: 'UI/UX Design',
    category: 'Design',
    resourceCount: 3,
    resources: [
      { personId: 'p7', personName: 'Grace Taylor', role: 'UX Designer', proficiency: 5, photo: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=400' },
      { personId: 'p-isabella', personName: 'Isabella Garcia', role: 'Designer', proficiency: 4, photo: 'https://images.unsplash.com/photo-1487412720507-e7ab37f1c39e?w=400' },
      { personId: 'p-michael', personName: 'Michael Chen', role: 'Designer', proficiency: 5, photo: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400' },
    ],
  },
  {
    skillId: 'sk-figma',
    skillName: 'Figma',
    category: 'Design',
    resourceCount: 4,
    resources: [
      { personId: 'p7', personName: 'Grace Taylor', role: 'UX Designer', proficiency: 5, photo: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=400' },
      { personId: 'p-isabella', personName: 'Isabella Garcia', role: 'Designer', proficiency: 4, photo: 'https://images.unsplash.com/photo-1487412720507-e7ab37f1c39e?w=400' },
      { personId: 'p-michael', personName: 'Michael Chen', role: 'Designer', proficiency: 5, photo: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400' },
      { personId: 'p-lucas', personName: 'Lucas Thompson', role: 'Developer', proficiency: 3, photo: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400' },
    ],
  },
  {
    skillId: 'sk-user-research',
    skillName: 'User Research',
    category: 'Design',
    resourceCount: 2,
    resources: [
      { personId: 'p7', personName: 'Grace Taylor', role: 'UX Designer', proficiency: 5, photo: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=400' },
      { personId: 'p-nina', personName: 'Nina Patel', role: 'Designer', proficiency: 4, photo: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=400' },
    ],
  },
  // ── Delivery ────────────────────────────────────────────────────────────────
  {
    skillId: 'sk-agile',
    skillName: 'Agile / Scrum',
    category: 'Delivery',
    resourceCount: 8,
    resources: [
      { personId: 'p1', personName: 'Alice Johnson', role: 'Senior Project Manager', proficiency: 5, photo: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400' },
      { personId: 'p2', personName: 'Ben Carter', role: 'Project Manager', proficiency: 4, photo: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400' },
      { personId: 'p9', personName: 'Isla Roberts', role: 'QA Lead', proficiency: 4, photo: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400' },
      { personId: 'p5', personName: 'Emma Wilson', role: 'Senior Developer', proficiency: 3, photo: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400' },
      { personId: 'p-carlos', personName: 'Carlos Rodriguez', role: 'Project Manager', proficiency: 5, photo: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400' },
      { personId: 'p-emma-w', personName: 'Emma Williams', role: 'Project Manager', proficiency: 4, photo: 'https://images.unsplash.com/photo-1487412720507-e7ab37f1c39e?w=400' },
      { personId: 'p4', personName: 'David Smith', role: 'Lead Developer', proficiency: 3, photo: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400' },
      { personId: 'p12', personName: 'Liam Harris', role: 'Developer', proficiency: 3, photo: 'https://images.unsplash.com/photo-1463453091185-61582044d556?w=400' },
    ],
  },
  {
    skillId: 'sk-change-mgmt',
    skillName: 'Change Management',
    category: 'Delivery',
    resourceCount: 4,
    resources: [
      { personId: 'p3', personName: 'Catherine Davies', role: 'Senior Consultant', proficiency: 5, photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400' },
      { personId: 'p15', personName: 'Olivia Jackson', role: 'Change Manager', proficiency: 5, photo: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=400' },
      { personId: 'p11', personName: 'Katie White', role: 'Consultant', proficiency: 3, photo: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400' },
      { personId: 'p-carlos', personName: 'Carlos Rodriguez', role: 'Project Manager', proficiency: 3, photo: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400' },
    ],
  },
  {
    skillId: 'sk-risk-mgmt',
    skillName: 'Risk Management',
    category: 'Delivery',
    resourceCount: 5,
    resources: [
      { personId: 'p1', personName: 'Alice Johnson', role: 'Senior Project Manager', proficiency: 5, photo: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400' },
      { personId: 'p2', personName: 'Ben Carter', role: 'Project Manager', proficiency: 4, photo: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400' },
      { personId: 'p14', personName: 'Noah Martin', role: 'Solutions Architect', proficiency: 4, photo: 'https://images.unsplash.com/photo-1519345182560-3f2917c472ef?w=400' },
      { personId: 'p-carlos', personName: 'Carlos Rodriguez', role: 'Project Manager', proficiency: 3, photo: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400' },
      { personId: 'p-emma-w', personName: 'Emma Williams', role: 'Project Manager', proficiency: 3, photo: 'https://images.unsplash.com/photo-1487412720507-e7ab37f1c39e?w=400' },
    ],
  },
  {
    skillId: 'sk-stakeholder',
    skillName: 'Stakeholder Management',
    category: 'Delivery',
    resourceCount: 6,
    resources: [
      { personId: 'p1', personName: 'Alice Johnson', role: 'Senior Project Manager', proficiency: 5, photo: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400' },
      { personId: 'p2', personName: 'Ben Carter', role: 'Project Manager', proficiency: 5, photo: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400' },
      { personId: 'p3', personName: 'Catherine Davies', role: 'Senior Consultant', proficiency: 4, photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400' },
      { personId: 'p13', personName: 'Mia Thompson', role: 'Project Coordinator', proficiency: 4, photo: 'https://images.unsplash.com/photo-1487412720507-e7ab37f1c39e?w=400' },
      { personId: 'p-carlos', personName: 'Carlos Rodriguez', role: 'Project Manager', proficiency: 5, photo: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400' },
      { personId: 'p-emma-w', personName: 'Emma Williams', role: 'Project Manager', proficiency: 4, photo: 'https://images.unsplash.com/photo-1487412720507-e7ab37f1c39e?w=400' },
    ],
  },
  // ── Domain / Sector ─────────────────────────────────────────────────────────
  {
    skillId: 'sk-fin-services',
    skillName: 'Financial Services',
    category: 'Domain / Sector',
    resourceCount: 4,
    resources: [
      { personId: 'p3', personName: 'Catherine Davies', role: 'Senior Consultant', proficiency: 5, photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400' },
      { personId: 'p11', personName: 'Katie White', role: 'Consultant', proficiency: 4, photo: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400' },
      { personId: 'p14', personName: 'Noah Martin', role: 'Solutions Architect', proficiency: 3, photo: 'https://images.unsplash.com/photo-1519345182560-3f2917c472ef?w=400' },
      { personId: 'p1', personName: 'Alice Johnson', role: 'Senior Project Manager', proficiency: 3, photo: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400' },
    ],
  },
  {
    skillId: 'sk-public-sector',
    skillName: 'Public Sector',
    category: 'Domain / Sector',
    resourceCount: 3,
    resources: [
      { personId: 'p15', personName: 'Olivia Jackson', role: 'Change Manager', proficiency: 4, photo: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=400' },
      { personId: 'p6', personName: 'Frank Brown', role: 'Business Analyst', proficiency: 3, photo: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400' },
      { personId: 'p-emma-w', personName: 'Emma Williams', role: 'Project Manager', proficiency: 3, photo: 'https://images.unsplash.com/photo-1487412720507-e7ab37f1c39e?w=400' },
    ],
  },
  {
    skillId: 'sk-retail',
    skillName: 'Retail',
    category: 'Domain / Sector',
    resourceCount: 2,
    resources: [
      { personId: 'p13', personName: 'Mia Thompson', role: 'Project Coordinator', proficiency: 3, photo: 'https://images.unsplash.com/photo-1487412720507-e7ab37f1c39e?w=400' },
      { personId: 'p8', personName: 'Henry Evans', role: 'Data Analyst', proficiency: 3, photo: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400' },
    ],
  },
  // ── Leadership ──────────────────────────────────────────────────────────────
  {
    skillId: 'sk-team-lead',
    skillName: 'Team Leadership',
    category: 'Leadership',
    resourceCount: 6,
    resources: [
      { personId: 'p1', personName: 'Alice Johnson', role: 'Senior Project Manager', proficiency: 5, photo: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400' },
      { personId: 'p4', personName: 'David Smith', role: 'Lead Developer', proficiency: 5, photo: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400' },
      { personId: 'p3', personName: 'Catherine Davies', role: 'Senior Consultant', proficiency: 4, photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400' },
      { personId: 'p14', personName: 'Noah Martin', role: 'Solutions Architect', proficiency: 4, photo: 'https://images.unsplash.com/photo-1519345182560-3f2917c472ef?w=400' },
      { personId: 'p-carlos', personName: 'Carlos Rodriguez', role: 'Project Manager', proficiency: 4, photo: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400' },
      { personId: 'p9', personName: 'Isla Roberts', role: 'QA Lead', proficiency: 3, photo: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400' },
    ],
  },
  {
    skillId: 'sk-mentoring',
    skillName: 'Mentoring',
    category: 'Leadership',
    resourceCount: 4,
    resources: [
      { personId: 'p1', personName: 'Alice Johnson', role: 'Senior Project Manager', proficiency: 5, photo: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400' },
      { personId: 'p3', personName: 'Catherine Davies', role: 'Senior Consultant', proficiency: 4, photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400' },
      { personId: 'p15', personName: 'Olivia Jackson', role: 'Change Manager', proficiency: 3, photo: 'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=400' },
      { personId: 'p4', personName: 'David Smith', role: 'Lead Developer', proficiency: 3, photo: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400' },
    ],
  },
];

/** All unique category names in order */
export const SKILL_CATEGORIES = ['Technical', 'Design', 'Delivery', 'Domain / Sector', 'Leadership'] as const;

/** Skills grouped by category — used for accordion rendering */
export function getSkillsByCategory(): Record<string, Skill[]> {
  return SKILL_CATEGORIES.reduce(
    (acc, cat) => {
      acc[cat] = MOCK_SKILLS.filter((s) => s.category === cat);
      return acc;
    },
    {} as Record<string, Skill[]>,
  );
}
